import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Fieldset,
  Legend,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import Select from "react-select";

import { Link, useHistory, Redirect } from "react-router-dom";
import apiResponse from "../../../../services/apiResponse";
import CreateBloc from "./Blocs/CreateBloc";
import { accessRole } from "../../../../helpers/access_role";
import CustomSelect from "../../GlobalComponents/CustomSelect";
import moment from "moment";

var reformatEmployee = function (employee) {
  return employee.map(function (region) {
    var newObj = {};
    newObj["label"] = region.employee_nip + " - " + region.employee_full_name;
    newObj["value"] = region.employee_uuid;
    newObj["model"] = region;
    return newObj;
  });
};

var reformatRank = function (ranks) {
  return ranks.map(function (rank) {
    var newObj = {};
    newObj["label"] = rank.rank_name;
    newObj["value"] = rank.rank_uuid;
    newObj["model"] = rank;
    return newObj;
  });
};

var reformatType = function (regions) {
  return regions.map(function (region) {
    var newObj = {};
    newObj["label"] = region.retired_type_name;
    newObj["value"] = region.retired_type_uuid;
    return newObj;
  });
};

class IndexView extends Component {
  createBloc = new CreateBloc();
  queryParams = new URLSearchParams(window.location.search)

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {
        promotion_employee_uuid: "",
        promotion_period_promotion_uuid: props.uuid,
        promotion_rank_type: "",
        promotion_tmt_date: "",
        promotion_rank_tmt_old: "",
        promotion_rank_group_room: "",
        promotion_rank_group_room_old: "",
        promotion_year_period_old: "",
        promotion_year_period: "",
        promotion_month_period_old: "",
        promotion_month_period: "",
        promotion_rank_uuid_old: "",
        promotion_rank_uuid: "",
        promotion_position_name_old: "",
        promotion_position_name: "",
		promotion_jenis: ((props.pegawai_uuid!=null)?1:0),
      },
      JenisKenaikanPangkat: [
        { label: "Reguler", value: "12112af3-6747-49a5-8f9b-9b119011a6f1" },
        { label: "Struktural", value: "e10f46fd-31e9-459d-b713-246629c19c26" },
        { label: "Fungsional", value: "b86966d5-5932-461b-8ea9-7f427e36df4c" },
        { label: "Anumerta", value: "a15084b8-a27b-44ce-b466-8c78ef250f79" },
        { label: "Pengabdian", value: "6d6e4634-d333-47ea-8af6-b58312e5ac54" },
        {
          label: "Penyesuaian Ijazah",
          value: "95fda552-af80-46b3-998e-e570e6c5a7ce",
        },
        { label: "TNI", value: "15625ddc-e1e0-4add-ba79-f1b22501e4e3" },
      ],
      employeeItems: [],
      rankItems: [],
      employeeSelected: props.pegawai_uuid,
      pangkatSelected: "",
      typeItems: [],
      typeSelected: "",
      rankGroupRoom: "",
    };

  }

  submitData = async () => {
    const formData = generateFormData(this.state.dataForm); // 'document' disini adalah nama field FileInput. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto']
    await this.createBloc.fetchCreate(formData);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
		    promotion_jenis: ((this.props.pegawai_uuid!=null)?1:0),
        promotion_period_promotion_uuid: this.props.uuid,
        ...values,
      },
      confirm: true,
    });
    console.log(this.state.dataForm);
  };

  onChangePangkat = (rank) => {
    var model = rank.model;
    this.setState({
      pangkatSelected: rank.value,
      rankGroupRoom: model.rank_group_room,
      dataForm: {
        promotion_rank_group_room: model.rank_group_room,
        promotion_rank_uuid: rank.value,
      },
    });
  };
  onChangeEmployee = (employee) => {
    var model = employee.model;

    this.setState({
      employeeSelected: employee.value,
      employee_rank_group: model.employee_current_rank_group,
      promotion_rank_group_room_old: model.employee_current_rank_group_room,
      pangkatSelected: "",
      rankGroupRoom: "",
      promotion_rank_uuid: "",
      promotion_rank_group_room: "",
      dataForm: {
        promotion_rank_uuid_old: model.employee_current_rank_uuid,
        promotion_rank_group_room_old: model.employee_current_rank_group_room,
        promotion_rank_group_room: model.employee_current_rank_group_room,
        promotion_rank_tmt_old: model.employee_current_tmt_rank,
        promotion_employee_uuid: model.promotion_employee_uuid,
        promotion_year_period_old: model.rank_history_year_period,
        promotion_year_period: model.rank_history_year_period,
        promotion_month_period_old: model.rank_history_month_period,
        promotion_month_period: model.rank_history_month_period,
        promotion_rank_uuid_old: model.employee_current_rank_uuid,
        promotion_position_name_old: model.employee_current_position_name,
        promotion_position_name: model.employee_current_position_name,
        promotion_rank_name_old: model.employee_current_rank_name,
        promotion_rank_tmt_old_temp: moment(
          model.employee_current_tmt_rank
        ).format("DD-MM-YYYY"),
      },
    });
    console.log(this.state);

    this.createBloc.fetchRank({
      employee_rank_group: model.employee_current_rank_group,
      employee_rank_group_room: model.employee_current_rank_group_room,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.createBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.createBloc.employeeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              employeeItems: reformatEmployee(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.typeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              typeItems: reformatType(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              detailPeriode: response
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.rankChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              rankItems: reformatRank(response.result),
            });

            try {
              if (response.result != null){
                let res = response.result;
                // console.log(res, "PANGKAT")
                this.setState({
                  pangkatSelected: res[0].rank_uuid,
                  rankGroupRoom: res[0].rank_group_room
                })
              }
            } catch (error) { console.log('pangkat kosong') }
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.fetchEmployee();

    this.createBloc.fetchDetail({uuid: this.queryParams.get('uuid')});
  }

  componentWillUnmount() {
    this.createBloc.createChannel.unsubscribe()
    this.createBloc.employeeChannel.unsubscribe()
    this.createBloc.typeChannel.unsubscribe()
    this.createBloc.detailChannel.unsubscribe()
    this.createBloc.rankChannel.unsubscribe()
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card className="">
                <CardBody>
                  <CardTitle>Tambah Data Pegawai Kenaikan Pangkat</CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger ">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Pilih Pegawai 
                      </label>
                      <Col md="4">
                        <Select
                          value={this.state.employeeItems.filter(
                            (option) =>
                              option.value === this.state.employeeSelected
                          )}
                          onChange={this.onChangeEmployee}
                          required="required"
                          options={this.state.employeeItems}
                          classNamePrefix=""
                          placeholder="Pilih Pegawai"
                        />
                        <AvField
                          name="promotion_employee_uuid"
                          type="hidden"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="promotion_employee_uuid"
                          value={this.state.employeeSelected}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="promotion_rank_type"
                        className="col-md-3 col-form-label"
                      >
                        Jenis Kenaikan Pangkat{" "}
                        
                      </label>
                      <Col md="4">
                        <CustomSelect
                          name="promotion_rank_type"
                          required="required"
                          errorMessage="Pilih Jenis Kenaikan Pangkat"
                          options={this.state.JenisKenaikanPangkat}
                          placeholder="Pilih Jenis Kenaikan Pangkat"
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      ></label>
                      <Col md="4" className="text-center">
                        <label className="col-form-label">
                          PANGKAT LAMA
                        </label>
                      </Col>
                      <Col md="4" className="text-center">
                        <label className="col-form-label text-center">
                          PANGKAT USULAN
                        </label>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Pangkat 
                      </label>
                      <Col md="4">
                        <AvField
                          name="promotion_rank_name_old"
                          readOnly={true}
                          placeholder="Pangkat"
                          type="text"
                          errorMessage="Masukan Pangkat"
                          className="form-control"
                          rows="8"
                          id="promotion_rank_name_old"
                          value={this.state.dataForm.promotion_rank_name_old}
                        />
                      </Col>
                      <Col md="4">
                        <Select
                          value={this.state.rankItems.filter(
                            (option) =>
                              option.value === this.state.pangkatSelected
                          )}
                          onChange={this.onChangePangkat}
                          required="required"
                          options={this.state.rankItems}
                          classNamePrefix=""
                          placeholder="Pilih Pangkat"
                        />
                        <AvField
                          name="promotion_rank_uuid"
                          type="hidden"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="promotion_rank_uuid"
                          value={this.state.pangkatSelected}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        TMT Pangkat 
                      </label>
                      <Col md="4">
                        <AvField
                          name="promotion_rank_tmt_old"
                          readOnly={true}
                          placeholder="TMT Pangkat"
                          type="text"
                          errorMessage="Masukan TMT Pangkat"
                          className="form-control"
                          rows="8"
                          id="promotion_rank_tmt_old"
                          value={
                            this.state.dataForm.promotion_rank_tmt_old_temp
                          }
                        />
                      </Col>
                      <Col md="4">
                        <AvField
                          name="promotion_tmt_date"
                          placeholder="TMT Pangkat"
                          type="date"
                          errorMessage="Masukan TMT Pangkat"
                          className="form-control"
                          rows="8"
                          id="promotion_tmt_date"
                          validate={{ required: { value: true } }}
                          value={this.state.detailPeriode?.period_promotion_date}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Gol/Ruang 
                      </label>
                      <Col md="4">
                        <AvField
                          name="promotion_rank_group_room_old"
                          readOnly={true}
                          placeholder="Gol/Ruang"
                          type="text"
                          errorMessage="Masukan Gol/Ruang"
                          className="form-control"
                          rows="8"
                          id="promotion_rank_group_room_old"
                          value={
                            this.state.promotion_rank_group_room_old
                          }
                        />
                      </Col>
                      <Col md="4">
                        <AvField
                          name="promotion_rank_group_room"
                          placeholder="Gol/Ruang"
                          type="text"
                          errorMessage="Masukan Gol/Ruang"
                          className="form-control"
                          rows="8"
                          id="promotion_rank_group_room"
                          // value={this.state.dataForm.promotion_rank_group_room}
                          value={this.state.rankGroupRoom}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Masa Kerja 
                      </label>
                      <Col md="1">
                        <AvField
                          name="promotion_year_period_old"
                          readOnly={true}
                          placeholder="Tahun"
                          type="text"
                          errorMessage="Masukan Tahun"
                          className="form-control"
                          rows="8"
                          id="promotion_year_period_old"
                          value={this.state.dataForm.promotion_year_period_old}
                        />
                      </Col>
                      <Col md="1" className="text-center">
                        <label className="col-form-label">Tahun</label>
                      </Col>
                      <Col md="1">
                        <AvField
                          name="promotion_month_period_old"
                          readOnly={true}
                          placeholder="Bulan"
                          type="text"
                          errorMessage="Masukan Bulan"
                          className="form-control"
                          rows="8"
                          id="promotion_month_period_old"
                          value={this.state.dataForm.promotion_month_period_old}
                        />
                      </Col>
                      <Col md="1" className="text-center">
                        <label className="col-form-label">Bulan</label>
                      </Col>

                      <Col md="1">
                        <AvField
                          name="promotion_year_period"
                          placeholder="Tahun"
                          type="text"
                          errorMessage="Masukan Tahun"
                          className="form-control"
                          rows="8"
                          id="promotion_year_period"
                          value={this.state.dataForm.promotion_year_period}
                        />
                      </Col>
                      <Col md="1" className="text-center">
                        <label className="col-form-label">Tahun</label>
                      </Col>
                      <Col md="1">
                        <AvField
                          name="promotion_month_period"
                          placeholder="Bulan"
                          type="text"
                          errorMessage="Masukan Bulan"
                          className="form-control"
                          rows="8"
                          id="promotion_month_period"
                          value={this.state.dataForm.promotion_month_period}
                        />
                      </Col>
                      <Col md="1" className="text-center">
                        <label className="col-form-label">Bulan</label>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Jabatan 
                      </label>
                      <Col md="4">
                        <AvField
                          name="promotion_position_name_old"
                          readOnly={true}
                          placeholder="Jabatan"
                          type="text"
                          errorMessage="Masukan Jabatan"
                          className="form-control"
                          rows="8"
                          id="promotion_position_name_old"
                          value={
                            this.state.dataForm.promotion_position_name_old
                          }
                        />
                      </Col>
                      <Col md="4">
                        <AvField
                          name="promotion_position_name"
                          placeholder="Jabatan"
                          type="text"
                          errorMessage="Masukan Jabatan"
                          className="form-control"
                          rows="8"
                          id="promotion_position_name"
                          value={this.state.dataForm.promotion_position_name}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to={`?pegawai&uuid=`+this.props.uuid}>
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan Data
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect
            to={
              `/kepegawaian/kenaikan_pangkat.html?pegawai&uuid=` +
              this.props.uuid
            }
          />
        ) : null}
      </Fragment>
    );
  }
}

export default IndexView;
